/**
 * 기기 행 이름 변경 — 편집 칸 · 단추(설계서 §14.20). 🖥 관리 기기 · 🔖 ID로 추가한 기기(조직 공유) · 내 주소록이 함께 쓴다.
 *
 * 2026-10-12 사용자 실기 지적: ①[이름 변경] 이 **이름 바로 옆**에 있어 이름을 누르려다 잘못 눌림 → 오른쪽 단추 줄로 옮김
 * ②ID로 추가한 기기에는 이름 변경이 없었음 → 같은 부품으로 붙임.
 */

/** 이름 변경 편집 상태(편집 중인 행 하나만 열린다 — 부모가 들고 있다). */
export interface RenameState {
  active: boolean;
  value: string;
  onChange: (v: string) => void;
  onStart: () => void;
  onSubmit: () => void;
  onCancel: () => void;
}

/** 이름 자리에 펼치는 편집 칸 — Enter 저장 · Esc 취소. */
export function RenameEditor({ rename, busy, maxLength }: { rename: RenameState; busy: boolean; maxLength: number }) {
  return (
    <div className="row" style={{ gap: 6, alignItems: 'center' }}>
      <input
        autoFocus
        value={rename.value}
        maxLength={maxLength}
        onChange={(e) => rename.onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') rename.onSubmit();
          if (e.key === 'Escape') rename.onCancel();
        }}
        placeholder="기기 이름"
        aria-label="기기 이름"
        style={{ minWidth: 200 }}
      />
      <button onClick={rename.onSubmit} disabled={busy}>
        {busy ? '저장 중…' : '저장'}
      </button>
      <button className="ghost" onClick={rename.onCancel} disabled={busy}>
        취소
      </button>
    </div>
  );
}

/** 오른쪽 단추 줄의 [이름 변경]. 편집 중이면 숨긴다(같은 행에서 두 번 열지 않게). */
export function RenameButton({ rename, busy, title }: { rename: RenameState; busy: boolean; title: string }) {
  if (rename.active) return null;
  return (
    <button className="ghost" onClick={rename.onStart} disabled={busy} title={title}>
      이름 변경
    </button>
  );
}
